import { render, staticRenderFns } from "./AnimatedLargeCopy.vue?vue&type=template&id=1eaf80c8&"
import script from "./AnimatedLargeCopy.vue?vue&type=script&lang=js&"
export * from "./AnimatedLargeCopy.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedLargeCopy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports